import { SuiGrpcClient } from '@mysten/sui/grpc';
import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';
import { getSuiGrpcUrl, getSuiGrpcToken } from './rpcEndpoints';
// Cache one client (and its gRPC-web transport) per network. getSuiClient is called
// from many render/effect paths; recreating a SuiGrpcClient on every call added
// avoidable transport-setup overhead and contributed to the post-migration slowdown.
// dappKit.ts resolves its clients through here too, so the whole app shares one
// client/transport per network rather than one per consumer.
const clientCache = new Map();
export function getSuiClient(network) {
    const selectedNetwork = network || 'mainnet';
    const baseUrl = getSuiGrpcUrl(selectedNetwork);
    if (!baseUrl) {
        throw new Error(`Unsupported network: ${selectedNetwork}`);
    }
    const cached = clientCache.get(selectedNetwork);
    if (cached)
        return cached;
    const token = getSuiGrpcToken(selectedNetwork);
    // SuiGrpcClient's convenience constructor forwards only `baseUrl`/`fetchInit`
    // to the transport it builds and silently drops `meta` (read from
    // @mysten/sui 2.22.1's dist/grpc/client.mjs; it sets nothing else on the
    // transport, so this explicit construction loses no other defaults). Build
    // the transport ourselves — its `defaultOptions.meta` is merged into every
    // call as gRPC metadata (the `x-token` auth header). `meta` is written as a
    // direct property (not a conditional spread) so the compiler validates the
    // option name against GrpcWebOptions.
    const client = new SuiGrpcClient({
        network: selectedNetwork,
        transport: new GrpcWebFetchTransport({
            baseUrl,
            meta: token ? { 'x-token': token } : undefined,
        }),
    });
    clientCache.set(selectedNetwork, client);
    return client;
}
